/**
 * Copyright (c) Microblink Ltd. All rights reserved.
 */

export const defaultWasmModuleName = "BlinkCardWasmSDK";
export const nativeJsonizationEnabled = false;

export function defaultWasmFlavor()
{
    return "";
}
